<capra-button
  text="Use output"
  variant="secondary"
  size="small"
  color="neutral"
  icon="icon-caret-down"
  iconLocation="right"
  [matMenuTriggerFor]="disabled || (isExportingInProgress$ | async) ? null : menu"
  [disabled]="disabled || (isExportingInProgress$ | async)"
  data-test="use-output"
  (click)="onDropdownClick()"
></capra-button>
<mat-menu #menu="matMenu" xPosition="before" class="mat-menu-container">
  <ul>
    <li
      *ngIf="!thoughtspotIntegrated"
      role="button"
      (click)="!isOutputUsed && toggleReportState()"
      [class.disabled]="isOutputUsed"
      [attr.disabled]="isOutputUsed ? true : null"
      capraTooltip
      [tooltipIsDisabled]="isOutputUsed"
      tooltipPlacement="right"
      [tooltipContent]="'Add Output to Report (&#8984;/Ctrl + 1)'"
      data-test="add-output"
    >
      Add to Report Builder
    </li>
    <li
      *ngIf="!thoughtspotIntegrated"
      role="button"
      (click)="isOutputUsed && toggleReportState()"
      [class.disabled]="!isOutputUsed"
      [attr.disabled]="!isOutputUsed ? true : null"
      capraTooltip
      [tooltipIsDisabled]="!isOutputUsed"
      tooltipPlacement="right"
      [tooltipContent]="'Remove Output from Report (&#8984;/Ctrl + 2)'"
      data-test="remove-output"
    >
      Remove from Report Builder
    </li>
    <ng-container *ngIf="isPython$ | async">
      <div *ngIf="canShowReportActions" class="divider"></div>
      <li
        role="button"
        (click)="!isCellExported && handleCreateDataset()"
        capraTooltip
        [class.disabled]="isCellExported$ | async"
        [tooltipIsDisabled]="!(isCellExported$ | async)"
        tooltipPlacement="right"
        tooltipContent="A dataset has already been generated from this output cell"
        data-test="export-dataset"
      >
        Create a dataset (only supported for pandas.DataFrames)
      </li>
    </ng-container>
  </ul>
</mat-menu>
